import Vuex, { Store } from 'vuex';
import Vue from 'vue';

// eslint-disable-next-line import/no-named-as-default
import VuexPersistence from 'vuex-persist';

import Common from './modules/Common';
import request from './modules/request';
import AlertHelper from './modules/AlertHelper';
import LeaveAlertHelper from './modules/LeaveAlertHelper';
import MediaPopupHelper from './modules/MediaPopupHelper';

Vue.use(Vuex)


export default new Store({
  namespaced: true,
  modules: {
    Common,
    request,
    AlertHelper,
    LeaveAlertHelper,
    MediaPopupHelper
  },
  plugins: [
    new VuexPersistence({
      key: 'vuex',
      storage: window.localStorage,
      modules: [],
    }).plugin,
  ],
})
